import React, { Component } from "react";

import styles from "./styles.scss";
import { connect } from "react-redux";
import { actions } from "./redux";
import { Grid, Card, CardContent } from "@material-ui/core";
import CSSModules from "react-css-modules";
import { number } from "../../utils";
import { actions as metertreeactions } from "../../components/LiveComponents/MeterTree/redux";

import MeterTree from "../../components/LiveComponents/MeterTree/MeterTree";
import CostPerHourChart from "../../components/LiveComponents/CostPerHourChart/CostPerHourChart";
import MonthlyCostComparisonChart from "../../components/LiveComponents/MonthlyCostComparisonChart/MonthlyCostComparisonChart";
import MonthlyUsageComparisonChart from "../../components/LiveComponents/MonthlyUsageComparisonChart/MonthlyUsageComparisonChart";
import LiveLineChart from "../../components/LiveComponents/LiveLineChart/LiveLineChart";
import WeeklySummaryTable from "../../components/LiveComponents/WeeklySummaryTable/WeeklySummaryTable";

import liveFlag from "../../assets/Icons/live-flag.png";
import { Interval } from "../../services/Live/types";

@CSSModules(styles, { allowMultiple: true })
class Live extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isdebug: this.props.match.params.isdebug
		}
    }
    
	componentDidMount() {
        this.props.startComponent();
        this.props.startFaker();
        this.props.startFaker2();
    }

    componentWillUnmount(){
        this.props.stopComponent();
    }

	render() {	
		return (
            <Grid container styleName="page-wrapper">
                <Grid item xs={12} styleName="item-wrapper">
                    <Card styleName="live-card">
                        {this.renderLiveHeader()}
                    </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} styleName="item-wrapper">
                            <Card styleName="live-card item-bordered">
                                <CardContent>
                                    <MeterTree units={this.props.selectedType} isdebug={this.state.isdebug} />
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} styleName="item-wrapper">
                            <Card styleName="live-card">
                                <MonthlyCostComparisonChart />
                            </Card>
                        </Grid>
                        <Grid item xs={12} styleName="item-wrapper">
                            <Card styleName="live-card">
                                <MonthlyUsageComparisonChart />
                            </Card>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={0}>
                        <Grid item xs={12} styleName="item-wrapper">
                            <Card styleName="live-card chart-item">
                                <CostPerHourChart />
                            </Card>
                        </Grid>
                        {this.props.lineGraphConfig.map((config, index) =>              
                        <Grid item xs={12} styleName="item-wrapper" key={(config && config ? config.objectID : index)}>
                            <Card styleName="live-card chart-item">
                                <LiveLineChart rootView={config} />
                            </Card>
                        </Grid>
                        )}
                        <Grid item xs={12} styleName="item-wrapper">
                        <Card styleName="live-card">
                            <CardContent>
                                <WeeklySummaryTable />
                            </CardContent>
                        </Card>
                    </Grid>
                    </Grid>
                </Grid>
			</Grid>
		);
    }

    getSiteName(){
        let siteName = "";
        if(this.props.currentSite){
            siteName = this.props.currentSite.name;
        }
        siteName = siteName.replace("Site_", "");
        return siteName;
    }

    format(x, decimals){
		if(!x){ return 0; }
		if(decimals !== null && decimals !== undefined){
            x = number.parseNumber(x, decimals);
		}
		var parts = x.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
    
    renderLiveHeader(){
        return(
            <div styleName="live-header">
                <div styleName="live-header-title">
                    <div>{this.getSiteName()}</div>
                </div>
                <div styleName="live-header-flag">
                    <img src={liveFlag} styleName="live-header-flag-image" />
                    <div styleName="live-header-flag-text">
                        <div>
                            Live
                        </div>
                    </div>
                </div>
                <Grid container styleName="live-header-content" spacing={0}>
                    {this.props.liveTypes.map((liveType, index) => 
                        <Grid item xs={6} md={3} styleName="live-header-type" isselected={(liveType.units === this.props.selectedType).toString()} key={index} onClick={() => this.props.selectType(liveType.units)}>
                            <div>
                                {liveType.unitsPlacement === "before" && 
                                    <span styleName="live-header-units" unitsize={(liveType.unitsSize).toString()}>
                                        {liveType.units}&nbsp;
                                    </span>
                                }
                                <span styleName="live-header-value">
                                    {
                                        liveType.units === "$" &&
                                        number.parseNumber(liveType.displayValue, 2)
                                    }
                                    {
                                        liveType.units !== "$" &&
                                        number.parseNumber(liveType.value, 0)
                                    }
                                </span>
                                {liveType.unitsPlacement === "after" && 
                                    <span styleName="live-header-units" unitsize={(liveType.unitsSize).toString()}>
                                        &nbsp;{liveType.units}
                                    </span>
                                }
                            </div>
                            <div styleName="live-header-sub-text">
                                {liveType.subText}
                            </div>
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}

const bindAction = dispatch => {
	return {
        startComponent: () => dispatch(actions.startComponent()),
        startFaker: () => dispatch(actions.startFaker()),
        stopComponent: () => dispatch(actions.stopComponent()),
        selectType: (units) => dispatch(actions.selectType(units)),
        startFaker2: () => dispatch(metertreeactions.startFaker()),
	};
};

const mapStateToProps = state => ({
    liveTypes: state.live.liveTypes,
    selectedType: state.live.selectedType,
    currentSite: state.sitetree.currentSite,
    lineGraphConfig: state.live.lineGraphConfig,
    rerender: state.live.rerender,
    interval: state.live.interval,
});

export default connect(mapStateToProps, bindAction)(Live);



// WEBPACK FOOTER //
// ./src/ui/Live/Live.js